import React from "react";

import History from "../../components/history/history.component";

const HistoryPage = () => {
  return <History />;
};

export default HistoryPage;
